import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultTable from "../../../components/table/ResultTable";
import EmptyLine from "../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B11({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XCL001.error_id: {
            return `RS ${row.cross_section}: XS GIS CutLine points can not parse!`
        }
        case MessageCodes.Internal.XY03.error_id: {
            return (
                <>
                    <ResultText>
                        There are {row?.data?.length} cross sections where Cutline Length is not equal to Cross-Section Length. These cross-sections and corresponding cutline length ratios (r) are listed in the following table. If the length ratio is due to an applied skew, the r value is highlighted in green text.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Length Ratio, r</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            (row.data).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={r.cross_section} /> {r.skew ? ` (skew ${r?.skew})` : ''}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            <div style={{color: r?.marked === false ? 'green' : ''}}>
                                                {r.ratio}
                                            </div>
                                        </ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.XY04.error_id: {
            return (
                <>
                    <ResultText>
                        Cutline Length could not be calculated for the following {row?.data?.length} cross sections since they are not georeferenced:
                    </ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Internal.XY19.error_id: {
            const threshold = row?.data?.[0]?.threshold ?? settings?.thresholds?.deflection_angle
            return (
                <>
                    <ResultText>
                        There is a sharp turn at the cross section cutline segments at the following {row?.data?.length} cross sections. The cross sections with more than {threshold} degrees are listed below.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(20)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(25)}}>
                                    Deflection Angle (degrees)
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.deflection_angle}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}